module.exports = __webpack_public_path__ + "img/businessman.1364695c.svg";